export type Json =
  | string
  | number
  | boolean
  | null
  | { [key: string]: Json | undefined }
  | Json[]

export type Database = {
  graphql_public: {
    Tables: {
      [_ in never]: never
    }
    Views: {
      [_ in never]: never
    }
    Functions: {
      graphql: {
        Args: {
          extensions?: Json
          operationName?: string
          query?: string
          variables?: Json
        }
        Returns: Json
      }
    }
    Enums: {
      [_ in never]: never
    }
    CompositeTypes: {
      [_ in never]: never
    }
  }
  public: {
    Tables: {
      cities: {
        Row: {
          city_id: number
          city_name: string
          country: string
          state: string
        }
        Insert: {
          city_id?: number
          city_name: string
          country: string
          state: string
        }
        Update: {
          city_id?: number
          city_name?: string
          country?: string
          state?: string
        }
        Relationships: []
      }
      event_participants: {
        Row: {
          created_at: string
          event_id: string
          event_participant_id: string
          participant_type: Database["public"]["Enums"]["participant_type"]
          user_id: string
        }
        Insert: {
          created_at?: string
          event_id: string
          event_participant_id?: string
          participant_type?: Database["public"]["Enums"]["participant_type"]
          user_id: string
        }
        Update: {
          created_at?: string
          event_id?: string
          event_participant_id?: string
          participant_type?: Database["public"]["Enums"]["participant_type"]
          user_id?: string
        }
        Relationships: [
          {
            foreignKeyName: "event_participants_event_id_fkey"
            columns: ["event_id"]
            isOneToOne: false
            referencedRelation: "events"
            referencedColumns: ["event_id"]
          },
          {
            foreignKeyName: "event_participants_event_id_fkey"
            columns: ["event_id"]
            isOneToOne: false
            referencedRelation: "events_unaccent"
            referencedColumns: ["event_id"]
          },
        ]
      }
      events: {
        Row: {
          address: string
          city: string
          country: string
          coupon_code: string | null
          coupon_label: string | null
          created_at: string
          date_and_time: string
          description: string
          event_id: string
          event_tags: Database["public"]["Enums"]["event_tag"][] | null
          host_name: string | null
          host_social_url: string | null
          image_url: string | null
          is_paid: boolean | null
          lat: number | null
          lng: number | null
          music_tags: Database["public"]["Enums"]["music_tag"][] | null
          place_id: string
          state: string
          ticket_purchase_url: string | null
          title: string
          updated_at: string
          venue_tags: Database["public"]["Enums"]["venue_tag"][] | null
        }
        Insert: {
          address: string
          city: string
          country: string
          coupon_code?: string | null
          coupon_label?: string | null
          created_at?: string
          date_and_time: string
          description: string
          event_id?: string
          event_tags?: Database["public"]["Enums"]["event_tag"][] | null
          host_name?: string | null
          host_social_url?: string | null
          image_url?: string | null
          is_paid?: boolean | null
          lat?: number | null
          lng?: number | null
          music_tags?: Database["public"]["Enums"]["music_tag"][] | null
          place_id: string
          state: string
          ticket_purchase_url?: string | null
          title: string
          updated_at?: string
          venue_tags?: Database["public"]["Enums"]["venue_tag"][] | null
        }
        Update: {
          address?: string
          city?: string
          country?: string
          coupon_code?: string | null
          coupon_label?: string | null
          created_at?: string
          date_and_time?: string
          description?: string
          event_id?: string
          event_tags?: Database["public"]["Enums"]["event_tag"][] | null
          host_name?: string | null
          host_social_url?: string | null
          image_url?: string | null
          is_paid?: boolean | null
          lat?: number | null
          lng?: number | null
          music_tags?: Database["public"]["Enums"]["music_tag"][] | null
          place_id?: string
          state?: string
          ticket_purchase_url?: string | null
          title?: string
          updated_at?: string
          venue_tags?: Database["public"]["Enums"]["venue_tag"][] | null
        }
        Relationships: [
          {
            foreignKeyName: "events_place_id_fkey"
            columns: ["place_id"]
            isOneToOne: false
            referencedRelation: "place_details"
            referencedColumns: ["place_id"]
          },
          {
            foreignKeyName: "events_place_id_fkey"
            columns: ["place_id"]
            isOneToOne: false
            referencedRelation: "places"
            referencedColumns: ["place_id"]
          },
          {
            foreignKeyName: "events_place_id_fkey"
            columns: ["place_id"]
            isOneToOne: false
            referencedRelation: "places_unaccent"
            referencedColumns: ["place_id"]
          },
        ]
      }
      followers: {
        Row: {
          created_at: string
          follower_id: string
          following_id: string
        }
        Insert: {
          created_at?: string
          follower_id: string
          following_id: string
        }
        Update: {
          created_at?: string
          follower_id?: string
          following_id?: string
        }
        Relationships: [
          {
            foreignKeyName: "followers_follower_id_fkey"
            columns: ["follower_id"]
            isOneToOne: false
            referencedRelation: "profiles"
            referencedColumns: ["user_id"]
          },
          {
            foreignKeyName: "followers_follower_id_fkey"
            columns: ["follower_id"]
            isOneToOne: false
            referencedRelation: "profiles_unaccent"
            referencedColumns: ["user_id"]
          },
          {
            foreignKeyName: "followers_following_id_fkey"
            columns: ["following_id"]
            isOneToOne: false
            referencedRelation: "profiles"
            referencedColumns: ["user_id"]
          },
          {
            foreignKeyName: "followers_following_id_fkey"
            columns: ["following_id"]
            isOneToOne: false
            referencedRelation: "profiles_unaccent"
            referencedColumns: ["user_id"]
          },
        ]
      }
      invites: {
        Row: {
          accepted_at: string | null
          created_at: string | null
          email: string
          id: string
          invited_by: string | null
          status: string
        }
        Insert: {
          accepted_at?: string | null
          created_at?: string | null
          email: string
          id?: string
          invited_by?: string | null
          status?: string
        }
        Update: {
          accepted_at?: string | null
          created_at?: string | null
          email?: string
          id?: string
          invited_by?: string | null
          status?: string
        }
        Relationships: []
      }
      otp_codes: {
        Row: {
          code: string
          created_at: string | null
          email: string
          expires_at: string
          id: string
          used: boolean
        }
        Insert: {
          code: string
          created_at?: string | null
          email: string
          expires_at: string
          id?: string
          used?: boolean
        }
        Update: {
          code?: string
          created_at?: string | null
          email?: string
          expires_at?: string
          id?: string
          used?: boolean
        }
        Relationships: []
      }
      places: {
        Row: {
          address: string
          city: string
          country: string
          created_at: string
          description: string | null
          image_url: string | null
          instagram_username: string | null
          is_active: boolean
          lat: number | null
          lng: number | null
          name: string
          neighborhood: string | null
          place_id: string
          slug: string
          state: string
          updated_at: string
          venue_tags: Database["public"]["Enums"]["venue_tag"][] | null
          website_url: string | null
        }
        Insert: {
          address: string
          city: string
          country: string
          created_at?: string
          description?: string | null
          image_url?: string | null
          instagram_username?: string | null
          is_active?: boolean
          lat?: number | null
          lng?: number | null
          name: string
          neighborhood?: string | null
          place_id?: string
          slug: string
          state: string
          updated_at?: string
          venue_tags?: Database["public"]["Enums"]["venue_tag"][] | null
          website_url?: string | null
        }
        Update: {
          address?: string
          city?: string
          country?: string
          created_at?: string
          description?: string | null
          image_url?: string | null
          instagram_username?: string | null
          is_active?: boolean
          lat?: number | null
          lng?: number | null
          name?: string
          neighborhood?: string | null
          place_id?: string
          slug?: string
          state?: string
          updated_at?: string
          venue_tags?: Database["public"]["Enums"]["venue_tag"][] | null
          website_url?: string | null
        }
        Relationships: []
      }
      profiles: {
        Row: {
          avatar_url: string | null
          city: string | null
          country: string | null
          created_at: string
          display_name: string | null
          instagram_username: string | null
          profile_id: string
          should_show_instagram: boolean
          state: string | null
          updated_at: string
          user_id: string
          username: string
        }
        Insert: {
          avatar_url?: string | null
          city?: string | null
          country?: string | null
          created_at?: string
          display_name?: string | null
          instagram_username?: string | null
          profile_id?: string
          should_show_instagram?: boolean
          state?: string | null
          updated_at?: string
          user_id: string
          username: string
        }
        Update: {
          avatar_url?: string | null
          city?: string | null
          country?: string | null
          created_at?: string
          display_name?: string | null
          instagram_username?: string | null
          profile_id?: string
          should_show_instagram?: boolean
          state?: string | null
          updated_at?: string
          user_id?: string
          username?: string
        }
        Relationships: []
      }
      push_tokens: {
        Row: {
          created_at: string
          device_name: string | null
          id: string
          platform: string
          token: string
          updated_at: string
          user_id: string
        }
        Insert: {
          created_at?: string
          device_name?: string | null
          id?: string
          platform: string
          token: string
          updated_at?: string
          user_id: string
        }
        Update: {
          created_at?: string
          device_name?: string | null
          id?: string
          platform?: string
          token?: string
          updated_at?: string
          user_id?: string
        }
        Relationships: []
      }
      reports: {
        Row: {
          created_at: string
          details: string | null
          reasons: string[]
          report_id: string
          reported_user_id: string
          reporter_user_id: string
          status: Database["public"]["Enums"]["report_status"]
          updated_at: string
        }
        Insert: {
          created_at?: string
          details?: string | null
          reasons: string[]
          report_id?: string
          reported_user_id: string
          reporter_user_id: string
          status?: Database["public"]["Enums"]["report_status"]
          updated_at?: string
        }
        Update: {
          created_at?: string
          details?: string | null
          reasons?: string[]
          report_id?: string
          reported_user_id?: string
          reporter_user_id?: string
          status?: Database["public"]["Enums"]["report_status"]
          updated_at?: string
        }
        Relationships: []
      }
      saved_places: {
        Row: {
          created_at: string
          place_id: string
          saved_place_id: string
          user_id: string
        }
        Insert: {
          created_at?: string
          place_id: string
          saved_place_id?: string
          user_id: string
        }
        Update: {
          created_at?: string
          place_id?: string
          saved_place_id?: string
          user_id?: string
        }
        Relationships: [
          {
            foreignKeyName: "saved_places_place_id_fkey"
            columns: ["place_id"]
            isOneToOne: false
            referencedRelation: "place_details"
            referencedColumns: ["place_id"]
          },
          {
            foreignKeyName: "saved_places_place_id_fkey"
            columns: ["place_id"]
            isOneToOne: false
            referencedRelation: "places"
            referencedColumns: ["place_id"]
          },
          {
            foreignKeyName: "saved_places_place_id_fkey"
            columns: ["place_id"]
            isOneToOne: false
            referencedRelation: "places_unaccent"
            referencedColumns: ["place_id"]
          },
        ]
      }
      states: {
        Row: {
          country: string
          state: string
          state_id: number
        }
        Insert: {
          country: string
          state: string
          state_id?: number
        }
        Update: {
          country?: string
          state?: string
          state_id?: number
        }
        Relationships: []
      }
    }
    Views: {
      event_participant_details: {
        Row: {
          event_address: string | null
          event_city: string | null
          event_country: string | null
          event_created_at: string | null
          event_date_and_time: string | null
          event_description: string | null
          event_event_tags: Database["public"]["Enums"]["event_tag"][] | null
          event_host_name: string | null
          event_host_social_url: string | null
          event_id: string | null
          event_image_url: string | null
          event_is_paid: boolean | null
          event_music_tags: Database["public"]["Enums"]["music_tag"][] | null
          event_participant_created_at: string | null
          event_participant_id: string | null
          event_place_id: string | null
          event_state: string | null
          event_ticket_purchase_url: string | null
          event_title: string | null
          event_updated_at: string | null
          event_venue_tags: Database["public"]["Enums"]["venue_tag"][] | null
          participant_type:
            | Database["public"]["Enums"]["participant_type"]
            | null
          profile_avatar_url: string | null
          profile_city: string | null
          profile_country: string | null
          profile_created_at: string | null
          profile_display_name: string | null
          profile_id: string | null
          profile_instagram_username: string | null
          profile_state: string | null
          profile_updated_at: string | null
          profile_username: string | null
          user_id: string | null
        }
        Relationships: [
          {
            foreignKeyName: "event_participants_event_id_fkey"
            columns: ["event_id"]
            isOneToOne: false
            referencedRelation: "events"
            referencedColumns: ["event_id"]
          },
          {
            foreignKeyName: "event_participants_event_id_fkey"
            columns: ["event_id"]
            isOneToOne: false
            referencedRelation: "events_unaccent"
            referencedColumns: ["event_id"]
          },
          {
            foreignKeyName: "events_place_id_fkey"
            columns: ["event_place_id"]
            isOneToOne: false
            referencedRelation: "place_details"
            referencedColumns: ["place_id"]
          },
          {
            foreignKeyName: "events_place_id_fkey"
            columns: ["event_place_id"]
            isOneToOne: false
            referencedRelation: "places"
            referencedColumns: ["place_id"]
          },
          {
            foreignKeyName: "events_place_id_fkey"
            columns: ["event_place_id"]
            isOneToOne: false
            referencedRelation: "places_unaccent"
            referencedColumns: ["place_id"]
          },
        ]
      }
      event_participants_preview: {
        Row: {
          event_id: string | null
          participant_count: number | null
          participant_rank: number | null
          profile_avatar_url: string | null
          profile_display_name: string | null
          profile_id: string | null
          profile_username: string | null
          user_id: string | null
        }
        Relationships: [
          {
            foreignKeyName: "event_participants_event_id_fkey"
            columns: ["event_id"]
            isOneToOne: false
            referencedRelation: "events"
            referencedColumns: ["event_id"]
          },
          {
            foreignKeyName: "event_participants_event_id_fkey"
            columns: ["event_id"]
            isOneToOne: false
            referencedRelation: "events_unaccent"
            referencedColumns: ["event_id"]
          },
        ]
      }
      events_unaccent: {
        Row: {
          address: string | null
          city: string | null
          country: string | null
          created_at: string | null
          date_and_time: string | null
          description: string | null
          description_unaccent: string | null
          event_id: string | null
          event_tags: Database["public"]["Enums"]["event_tag"][] | null
          host_name: string | null
          host_name_unaccent: string | null
          host_social_url: string | null
          image_url: string | null
          is_paid: boolean | null
          lat: number | null
          lng: number | null
          music_tags: Database["public"]["Enums"]["music_tag"][] | null
          state: string | null
          ticket_purchase_url: string | null
          title: string | null
          title_unaccent: string | null
          updated_at: string | null
          venue_tags: Database["public"]["Enums"]["venue_tag"][] | null
        }
        Insert: {
          address?: string | null
          city?: string | null
          country?: string | null
          created_at?: string | null
          date_and_time?: string | null
          description?: string | null
          description_unaccent?: never
          event_id?: string | null
          event_tags?: Database["public"]["Enums"]["event_tag"][] | null
          host_name?: string | null
          host_name_unaccent?: never
          host_social_url?: string | null
          image_url?: string | null
          is_paid?: boolean | null
          lat?: number | null
          lng?: number | null
          music_tags?: Database["public"]["Enums"]["music_tag"][] | null
          state?: string | null
          ticket_purchase_url?: string | null
          title?: string | null
          title_unaccent?: never
          updated_at?: string | null
          venue_tags?: Database["public"]["Enums"]["venue_tag"][] | null
        }
        Update: {
          address?: string | null
          city?: string | null
          country?: string | null
          created_at?: string | null
          date_and_time?: string | null
          description?: string | null
          description_unaccent?: never
          event_id?: string | null
          event_tags?: Database["public"]["Enums"]["event_tag"][] | null
          host_name?: string | null
          host_name_unaccent?: never
          host_social_url?: string | null
          image_url?: string | null
          is_paid?: boolean | null
          lat?: number | null
          lng?: number | null
          music_tags?: Database["public"]["Enums"]["music_tag"][] | null
          state?: string | null
          ticket_purchase_url?: string | null
          title?: string | null
          title_unaccent?: never
          updated_at?: string | null
          venue_tags?: Database["public"]["Enums"]["venue_tag"][] | null
        }
        Relationships: []
      }
      place_details: {
        Row: {
          address: string | null
          city: string | null
          country: string | null
          created_at: string | null
          description: string | null
          image_url: string | null
          instagram_username: string | null
          is_active: boolean | null
          lat: number | null
          lng: number | null
          name: string | null
          neighborhood: string | null
          place_id: string | null
          saved_count: number | null
          slug: string | null
          state: string | null
          updated_at: string | null
          venue_tags: Database["public"]["Enums"]["venue_tag"][] | null
          website_url: string | null
        }
        Relationships: []
      }
      places_unaccent: {
        Row: {
          address: string | null
          city: string | null
          country: string | null
          created_at: string | null
          description: string | null
          description_unaccent: string | null
          image_url: string | null
          instagram_username: string | null
          is_active: boolean | null
          lat: number | null
          lng: number | null
          name: string | null
          name_unaccent: string | null
          neighborhood: string | null
          place_id: string | null
          slug: string | null
          state: string | null
          updated_at: string | null
          venue_tags: Database["public"]["Enums"]["venue_tag"][] | null
          website_url: string | null
        }
        Insert: {
          address?: string | null
          city?: string | null
          country?: string | null
          created_at?: string | null
          description?: string | null
          description_unaccent?: never
          image_url?: string | null
          instagram_username?: string | null
          is_active?: boolean | null
          lat?: number | null
          lng?: number | null
          name?: string | null
          name_unaccent?: never
          neighborhood?: string | null
          place_id?: string | null
          slug?: string | null
          state?: string | null
          updated_at?: string | null
          venue_tags?: Database["public"]["Enums"]["venue_tag"][] | null
          website_url?: string | null
        }
        Update: {
          address?: string | null
          city?: string | null
          country?: string | null
          created_at?: string | null
          description?: string | null
          description_unaccent?: never
          image_url?: string | null
          instagram_username?: string | null
          is_active?: boolean | null
          lat?: number | null
          lng?: number | null
          name?: string | null
          name_unaccent?: never
          neighborhood?: string | null
          place_id?: string | null
          slug?: string | null
          state?: string | null
          updated_at?: string | null
          venue_tags?: Database["public"]["Enums"]["venue_tag"][] | null
          website_url?: string | null
        }
        Relationships: []
      }
      profiles_unaccent: {
        Row: {
          avatar_url: string | null
          display_name: string | null
          display_name_unaccent: string | null
          user_id: string | null
          username: string | null
          username_unaccent: string | null
        }
        Insert: {
          avatar_url?: string | null
          display_name?: string | null
          display_name_unaccent?: never
          user_id?: string | null
          username?: string | null
          username_unaccent?: never
        }
        Update: {
          avatar_url?: string | null
          display_name?: string | null
          display_name_unaccent?: never
          user_id?: string | null
          username?: string | null
          username_unaccent?: never
        }
        Relationships: []
      }
    }
    Functions: {
      backfill_places_from_events: { Args: never; Returns: number }
      delete_user: { Args: never; Returns: undefined }
      get_user_id_by_email: { Args: { lookup_email: string }; Returns: string }
    }
    Enums: {
      event_tag:
        | "festa"
        | "sarau"
        | "artes"
        | "música"
        | "exposição"
        | "carnaval"
        | "esporte"
        | "manifestação"
      music_tag:
        | "mpb"
        | "sertanejo"
        | "funk"
        | "rock"
        | "pop"
        | "eletrônica"
        | "forró"
        | "samba"
        | "rap"
        | "jazz"
        | "hip-hop"
      participant_type: "confirmed" | "interested"
      report_status: "in_review" | "user_removed" | "invalid_report"
      venue_tag:
        | "bar"
        | "restaurante"
        | "clube"
        | "balada"
        | "cinema"
        | "teatro"
        | "museu"
        | "casa de shows"
        | "local público"
        | "centro cultural"
        | "parque"
    }
    CompositeTypes: {
      [_ in never]: never
    }
  }
  storage: {
    Tables: {
      buckets: {
        Row: {
          allowed_mime_types: string[] | null
          avif_autodetection: boolean | null
          created_at: string | null
          file_size_limit: number | null
          id: string
          name: string
          owner: string | null
          owner_id: string | null
          public: boolean | null
          type: Database["storage"]["Enums"]["buckettype"]
          updated_at: string | null
        }
        Insert: {
          allowed_mime_types?: string[] | null
          avif_autodetection?: boolean | null
          created_at?: string | null
          file_size_limit?: number | null
          id: string
          name: string
          owner?: string | null
          owner_id?: string | null
          public?: boolean | null
          type?: Database["storage"]["Enums"]["buckettype"]
          updated_at?: string | null
        }
        Update: {
          allowed_mime_types?: string[] | null
          avif_autodetection?: boolean | null
          created_at?: string | null
          file_size_limit?: number | null
          id?: string
          name?: string
          owner?: string | null
          owner_id?: string | null
          public?: boolean | null
          type?: Database["storage"]["Enums"]["buckettype"]
          updated_at?: string | null
        }
        Relationships: []
      }
      buckets_analytics: {
        Row: {
          created_at: string
          deleted_at: string | null
          format: string
          id: string
          name: string
          type: Database["storage"]["Enums"]["buckettype"]
          updated_at: string
        }
        Insert: {
          created_at?: string
          deleted_at?: string | null
          format?: string
          id?: string
          name: string
          type?: Database["storage"]["Enums"]["buckettype"]
          updated_at?: string
        }
        Update: {
          created_at?: string
          deleted_at?: string | null
          format?: string
          id?: string
          name?: string
          type?: Database["storage"]["Enums"]["buckettype"]
          updated_at?: string
        }
        Relationships: []
      }
      buckets_vectors: {
        Row: {
          created_at: string
          id: string
          type: Database["storage"]["Enums"]["buckettype"]
          updated_at: string
        }
        Insert: {
          created_at?: string
          id: string
          type?: Database["storage"]["Enums"]["buckettype"]
          updated_at?: string
        }
        Update: {
          created_at?: string
          id?: string
          type?: Database["storage"]["Enums"]["buckettype"]
          updated_at?: string
        }
        Relationships: []
      }
      iceberg_namespaces: {
        Row: {
          bucket_name: string
          catalog_id: string
          created_at: string
          id: string
          metadata: Json
          name: string
          updated_at: string
        }
        Insert: {
          bucket_name: string
          catalog_id: string
          created_at?: string
          id?: string
          metadata?: Json
          name: string
          updated_at?: string
        }
        Update: {
          bucket_name?: string
          catalog_id?: string
          created_at?: string
          id?: string
          metadata?: Json
          name?: string
          updated_at?: string
        }
        Relationships: [
          {
            foreignKeyName: "iceberg_namespaces_catalog_id_fkey"
            columns: ["catalog_id"]
            isOneToOne: false
            referencedRelation: "buckets_analytics"
            referencedColumns: ["id"]
          },
        ]
      }
      iceberg_tables: {
        Row: {
          bucket_name: string
          catalog_id: string
          created_at: string
          id: string
          location: string
          name: string
          namespace_id: string
          remote_table_id: string | null
          shard_id: string | null
          shard_key: string | null
          updated_at: string
        }
        Insert: {
          bucket_name: string
          catalog_id: string
          created_at?: string
          id?: string
          location: string
          name: string
          namespace_id: string
          remote_table_id?: string | null
          shard_id?: string | null
          shard_key?: string | null
          updated_at?: string
        }
        Update: {
          bucket_name?: string
          catalog_id?: string
          created_at?: string
          id?: string
          location?: string
          name?: string
          namespace_id?: string
          remote_table_id?: string | null
          shard_id?: string | null
          shard_key?: string | null
          updated_at?: string
        }
        Relationships: [
          {
            foreignKeyName: "iceberg_tables_catalog_id_fkey"
            columns: ["catalog_id"]
            isOneToOne: false
            referencedRelation: "buckets_analytics"
            referencedColumns: ["id"]
          },
          {
            foreignKeyName: "iceberg_tables_namespace_id_fkey"
            columns: ["namespace_id"]
            isOneToOne: false
            referencedRelation: "iceberg_namespaces"
            referencedColumns: ["id"]
          },
        ]
      }
      migrations: {
        Row: {
          executed_at: string | null
          hash: string
          id: number
          name: string
        }
        Insert: {
          executed_at?: string | null
          hash: string
          id: number
          name: string
        }
        Update: {
          executed_at?: string | null
          hash?: string
          id?: number
          name?: string
        }
        Relationships: []
      }
      objects: {
        Row: {
          bucket_id: string | null
          created_at: string | null
          id: string
          last_accessed_at: string | null
          metadata: Json | null
          name: string | null
          owner: string | null
          owner_id: string | null
          path_tokens: string[] | null
          updated_at: string | null
          user_metadata: Json | null
          version: string | null
        }
        Insert: {
          bucket_id?: string | null
          created_at?: string | null
          id?: string
          last_accessed_at?: string | null
          metadata?: Json | null
          name?: string | null
          owner?: string | null
          owner_id?: string | null
          path_tokens?: string[] | null
          updated_at?: string | null
          user_metadata?: Json | null
          version?: string | null
        }
        Update: {
          bucket_id?: string | null
          created_at?: string | null
          id?: string
          last_accessed_at?: string | null
          metadata?: Json | null
          name?: string | null
          owner?: string | null
          owner_id?: string | null
          path_tokens?: string[] | null
          updated_at?: string | null
          user_metadata?: Json | null
          version?: string | null
        }
        Relationships: [
          {
            foreignKeyName: "objects_bucketId_fkey"
            columns: ["bucket_id"]
            isOneToOne: false
            referencedRelation: "buckets"
            referencedColumns: ["id"]
          },
        ]
      }
      s3_multipart_uploads: {
        Row: {
          bucket_id: string
          created_at: string
          id: string
          in_progress_size: number
          key: string
          metadata: Json | null
          owner_id: string | null
          upload_signature: string
          user_metadata: Json | null
          version: string
        }
        Insert: {
          bucket_id: string
          created_at?: string
          id: string
          in_progress_size?: number
          key: string
          metadata?: Json | null
          owner_id?: string | null
          upload_signature: string
          user_metadata?: Json | null
          version: string
        }
        Update: {
          bucket_id?: string
          created_at?: string
          id?: string
          in_progress_size?: number
          key?: string
          metadata?: Json | null
          owner_id?: string | null
          upload_signature?: string
          user_metadata?: Json | null
          version?: string
        }
        Relationships: [
          {
            foreignKeyName: "s3_multipart_uploads_bucket_id_fkey"
            columns: ["bucket_id"]
            isOneToOne: false
            referencedRelation: "buckets"
            referencedColumns: ["id"]
          },
        ]
      }
      s3_multipart_uploads_parts: {
        Row: {
          bucket_id: string
          created_at: string
          etag: string
          id: string
          key: string
          owner_id: string | null
          part_number: number
          size: number
          upload_id: string
          version: string
        }
        Insert: {
          bucket_id: string
          created_at?: string
          etag: string
          id?: string
          key: string
          owner_id?: string | null
          part_number: number
          size?: number
          upload_id: string
          version: string
        }
        Update: {
          bucket_id?: string
          created_at?: string
          etag?: string
          id?: string
          key?: string
          owner_id?: string | null
          part_number?: number
          size?: number
          upload_id?: string
          version?: string
        }
        Relationships: [
          {
            foreignKeyName: "s3_multipart_uploads_parts_bucket_id_fkey"
            columns: ["bucket_id"]
            isOneToOne: false
            referencedRelation: "buckets"
            referencedColumns: ["id"]
          },
          {
            foreignKeyName: "s3_multipart_uploads_parts_upload_id_fkey"
            columns: ["upload_id"]
            isOneToOne: false
            referencedRelation: "s3_multipart_uploads"
            referencedColumns: ["id"]
          },
        ]
      }
      vector_indexes: {
        Row: {
          bucket_id: string
          created_at: string
          data_type: string
          dimension: number
          distance_metric: string
          id: string
          metadata_configuration: Json | null
          name: string
          updated_at: string
        }
        Insert: {
          bucket_id: string
          created_at?: string
          data_type: string
          dimension: number
          distance_metric: string
          id?: string
          metadata_configuration?: Json | null
          name: string
          updated_at?: string
        }
        Update: {
          bucket_id?: string
          created_at?: string
          data_type?: string
          dimension?: number
          distance_metric?: string
          id?: string
          metadata_configuration?: Json | null
          name?: string
          updated_at?: string
        }
        Relationships: [
          {
            foreignKeyName: "vector_indexes_bucket_id_fkey"
            columns: ["bucket_id"]
            isOneToOne: false
            referencedRelation: "buckets_vectors"
            referencedColumns: ["id"]
          },
        ]
      }
    }
    Views: {
      [_ in never]: never
    }
    Functions: {
      allow_any_operation: {
        Args: { expected_operations: string[] }
        Returns: boolean
      }
      allow_only_operation: {
        Args: { expected_operation: string }
        Returns: boolean
      }
      can_insert_object: {
        Args: { bucketid: string; metadata: Json; name: string; owner: string }
        Returns: undefined
      }
      extension: { Args: { name: string }; Returns: string }
      filename: { Args: { name: string }; Returns: string }
      foldername: { Args: { name: string }; Returns: string[] }
      get_common_prefix: {
        Args: { p_delimiter: string; p_key: string; p_prefix: string }
        Returns: string
      }
      get_size_by_bucket: {
        Args: never
        Returns: {
          bucket_id: string
          size: number
        }[]
      }
      list_multipart_uploads_with_delimiter: {
        Args: {
          bucket_id: string
          delimiter_param: string
          max_keys?: number
          next_key_token?: string
          next_upload_token?: string
          prefix_param: string
        }
        Returns: {
          created_at: string
          id: string
          key: string
        }[]
      }
      list_objects_with_delimiter: {
        Args: {
          _bucket_id: string
          delimiter_param: string
          max_keys?: number
          next_token?: string
          prefix_param: string
          sort_order?: string
          start_after?: string
        }
        Returns: {
          created_at: string
          id: string
          last_accessed_at: string
          metadata: Json
          name: string
          updated_at: string
        }[]
      }
      operation: { Args: never; Returns: string }
      search: {
        Args: {
          bucketname: string
          levels?: number
          limits?: number
          offsets?: number
          prefix: string
          search?: string
          sortcolumn?: string
          sortorder?: string
        }
        Returns: {
          created_at: string
          id: string
          last_accessed_at: string
          metadata: Json
          name: string
          updated_at: string
        }[]
      }
      search_by_timestamp: {
        Args: {
          p_bucket_id: string
          p_level: number
          p_limit: number
          p_prefix: string
          p_sort_column: string
          p_sort_column_after: string
          p_sort_order: string
          p_start_after: string
        }
        Returns: {
          created_at: string
          id: string
          key: string
          last_accessed_at: string
          metadata: Json
          name: string
          updated_at: string
        }[]
      }
      search_v2: {
        Args: {
          bucket_name: string
          levels?: number
          limits?: number
          prefix: string
          sort_column?: string
          sort_column_after?: string
          sort_order?: string
          start_after?: string
        }
        Returns: {
          created_at: string
          id: string
          key: string
          last_accessed_at: string
          metadata: Json
          name: string
          updated_at: string
        }[]
      }
    }
    Enums: {
      buckettype: "STANDARD" | "ANALYTICS" | "VECTOR"
    }
    CompositeTypes: {
      [_ in never]: never
    }
  }
}

type DatabaseWithoutInternals = Omit<Database, "__InternalSupabase">

type DefaultSchema = DatabaseWithoutInternals[Extract<keyof Database, "public">]

export type Tables<
  DefaultSchemaTableNameOrOptions extends
    | keyof (DefaultSchema["Tables"] & DefaultSchema["Views"])
    | { schema: keyof DatabaseWithoutInternals },
  TableName extends DefaultSchemaTableNameOrOptions extends {
    schema: keyof DatabaseWithoutInternals
  }
    ? keyof (DatabaseWithoutInternals[DefaultSchemaTableNameOrOptions["schema"]]["Tables"] &
        DatabaseWithoutInternals[DefaultSchemaTableNameOrOptions["schema"]]["Views"])
    : never = never,
> = DefaultSchemaTableNameOrOptions extends {
  schema: keyof DatabaseWithoutInternals
}
  ? (DatabaseWithoutInternals[DefaultSchemaTableNameOrOptions["schema"]]["Tables"] &
      DatabaseWithoutInternals[DefaultSchemaTableNameOrOptions["schema"]]["Views"])[TableName] extends {
      Row: infer R
    }
    ? R
    : never
  : DefaultSchemaTableNameOrOptions extends keyof (DefaultSchema["Tables"] &
        DefaultSchema["Views"])
    ? (DefaultSchema["Tables"] &
        DefaultSchema["Views"])[DefaultSchemaTableNameOrOptions] extends {
        Row: infer R
      }
      ? R
      : never
    : never

export type TablesInsert<
  DefaultSchemaTableNameOrOptions extends
    | keyof DefaultSchema["Tables"]
    | { schema: keyof DatabaseWithoutInternals },
  TableName extends DefaultSchemaTableNameOrOptions extends {
    schema: keyof DatabaseWithoutInternals
  }
    ? keyof DatabaseWithoutInternals[DefaultSchemaTableNameOrOptions["schema"]]["Tables"]
    : never = never,
> = DefaultSchemaTableNameOrOptions extends {
  schema: keyof DatabaseWithoutInternals
}
  ? DatabaseWithoutInternals[DefaultSchemaTableNameOrOptions["schema"]]["Tables"][TableName] extends {
      Insert: infer I
    }
    ? I
    : never
  : DefaultSchemaTableNameOrOptions extends keyof DefaultSchema["Tables"]
    ? DefaultSchema["Tables"][DefaultSchemaTableNameOrOptions] extends {
        Insert: infer I
      }
      ? I
      : never
    : never

export type TablesUpdate<
  DefaultSchemaTableNameOrOptions extends
    | keyof DefaultSchema["Tables"]
    | { schema: keyof DatabaseWithoutInternals },
  TableName extends DefaultSchemaTableNameOrOptions extends {
    schema: keyof DatabaseWithoutInternals
  }
    ? keyof DatabaseWithoutInternals[DefaultSchemaTableNameOrOptions["schema"]]["Tables"]
    : never = never,
> = DefaultSchemaTableNameOrOptions extends {
  schema: keyof DatabaseWithoutInternals
}
  ? DatabaseWithoutInternals[DefaultSchemaTableNameOrOptions["schema"]]["Tables"][TableName] extends {
      Update: infer U
    }
    ? U
    : never
  : DefaultSchemaTableNameOrOptions extends keyof DefaultSchema["Tables"]
    ? DefaultSchema["Tables"][DefaultSchemaTableNameOrOptions] extends {
        Update: infer U
      }
      ? U
      : never
    : never

export type Enums<
  DefaultSchemaEnumNameOrOptions extends
    | keyof DefaultSchema["Enums"]
    | { schema: keyof DatabaseWithoutInternals },
  EnumName extends DefaultSchemaEnumNameOrOptions extends {
    schema: keyof DatabaseWithoutInternals
  }
    ? keyof DatabaseWithoutInternals[DefaultSchemaEnumNameOrOptions["schema"]]["Enums"]
    : never = never,
> = DefaultSchemaEnumNameOrOptions extends {
  schema: keyof DatabaseWithoutInternals
}
  ? DatabaseWithoutInternals[DefaultSchemaEnumNameOrOptions["schema"]]["Enums"][EnumName]
  : DefaultSchemaEnumNameOrOptions extends keyof DefaultSchema["Enums"]
    ? DefaultSchema["Enums"][DefaultSchemaEnumNameOrOptions]
    : never

export type CompositeTypes<
  PublicCompositeTypeNameOrOptions extends
    | keyof DefaultSchema["CompositeTypes"]
    | { schema: keyof DatabaseWithoutInternals },
  CompositeTypeName extends PublicCompositeTypeNameOrOptions extends {
    schema: keyof DatabaseWithoutInternals
  }
    ? keyof DatabaseWithoutInternals[PublicCompositeTypeNameOrOptions["schema"]]["CompositeTypes"]
    : never = never,
> = PublicCompositeTypeNameOrOptions extends {
  schema: keyof DatabaseWithoutInternals
}
  ? DatabaseWithoutInternals[PublicCompositeTypeNameOrOptions["schema"]]["CompositeTypes"][CompositeTypeName]
  : PublicCompositeTypeNameOrOptions extends keyof DefaultSchema["CompositeTypes"]
    ? DefaultSchema["CompositeTypes"][PublicCompositeTypeNameOrOptions]
    : never

export const Constants = {
  graphql_public: {
    Enums: {},
  },
  public: {
    Enums: {
      event_tag: [
        "festa",
        "sarau",
        "artes",
        "música",
        "exposição",
        "carnaval",
        "esporte",
        "manifestação",
      ],
      music_tag: [
        "mpb",
        "sertanejo",
        "funk",
        "rock",
        "pop",
        "eletrônica",
        "forró",
        "samba",
        "rap",
        "jazz",
        "hip-hop",
      ],
      participant_type: ["confirmed", "interested"],
      report_status: ["in_review", "user_removed", "invalid_report"],
      venue_tag: [
        "bar",
        "restaurante",
        "clube",
        "balada",
        "cinema",
        "teatro",
        "museu",
        "casa de shows",
        "local público",
        "centro cultural",
        "parque",
      ],
    },
  },
  storage: {
    Enums: {
      buckettype: ["STANDARD", "ANALYTICS", "VECTOR"],
    },
  },
} as const

